import { ImageSpecs, imageType } from './ImageSpecs';
import { addImage } from './actions';
import { addImageAction } from './const';
export { imageNodeName, imageType, ImageAttr } from './ImageSpecs';
/** @deprecated Use `imageType` instead */
export const imgType = imageType;
export const Image = (builder) => {
    builder.use(ImageSpecs);
    builder.addAction(addImageAction, ({ schema }) => addImage(schema));
};
